module.exports = __webpack_public_path__ + "img/history_hi.e48994f5.jpg";